import { PolygraphyProductUrlType } from '../../../../../../../services/exports/Constants';

export default {
  form: {
    url_type: {
      options: {
        [PolygraphyProductUrlType.OnlineShop]: 'Sklep online',
        [PolygraphyProductUrlType.Storefront]: 'Witryna sklepu',
        [PolygraphyProductUrlType.Custom]: 'Własny',
      },
    },
  },
  labels: {
    save_changes_to_see_preview: 'Zapisz zmiany, aby zobaczyć podgląd',
  },
  buttons: {
    save_and_preview: 'Zapisz i podgląd',
  },
  toasts: {
    failed_to_load_data: 'Nie udało się załadować produktu',
    failed_to_save_changes: 'Nie udało się zapisać zmian!',
    changes_got_saved: 'Zmiany zostały zapisane!',
  },
};
